import PropTypes from 'prop-types'

import { Link, useRouteMatch } from 'react-router-dom'
import { isNullOrUndefined } from 'utils'
import Button from 'components/form/Button'
import { useConfirm } from 'features/dialog/Confirm'
import { success, fail } from 'features/toast/Toast'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchLinkedTracks,
  fetchUnlinkedTracks,
  linkTrackRight,
} from 'features/crux/tracker/list/trackerListSlice'
import TrackerServiceTooltip from 'features/crux/tracker/TrackerServiceTooltip'
import { cancelTrackMember } from 'features/crux/tracker/modal/request/requestTrackSlice'
import classNames from 'classnames'

const UnLinkedTrackItem = ({
  data: {
    trackId,
    role,
    trackName,
    trackLinkedServices,
    linkedServiceNamesTitle,
    population,
    lastEventTs,
    adAccountLinkStatus,
    requestId,
  },
}) => {
  const dispatch = useDispatch()
  const { isSubmitting } = useSelector(state => state.tracker.requestTrack)
  const { url } = useRouteMatch()
  const [LinkConfirm, showLinkConfirm] = useConfirm()
  const showPopulation =
    role === 'MASTER' || role === 'MEMBER' || adAccountLinkStatus === 'LINKED'

  const handleDelete = async ({ isConfirmed }) => {
    if (isConfirmed) {
      const { error, payload } = await dispatch(linkTrackRight(trackId))
      if (error) {
        fail(payload?.message || '알 수 없는 에러가 발생했습니다.')
      } else {
        success('해당 광고계정과 픽셀 & SDK 연동이 완료되었습니다.')
        dispatch(fetchLinkedTracks())
        dispatch(fetchUnlinkedTracks())
      }
    }
  }
  const handleCancel = async () => {
    const { error, payload } = await dispatch(
      cancelTrackMember({ trackId, requestId })
    )
    if (error) {
      fail(payload?.message || '알 수 없는 에러가 발생했습니다.')
    } else {
      success('멤버 요청을 취소하였습니다.')
      dispatch(fetchUnlinkedTracks())
    }
  }
  return (
    <>
      <td>
        <div className="inner_tbl">
          {adAccountLinkStatus === 'UNLINKED' && (
            <span className="f_right">
              <Link to={`${url}/${trackId}`} className="link_del">
                연동 해제됨
              </Link>
            </span>
          )}
          <Link to={`${url}/${trackId}`} className="link_txt">
            {trackName}
            <span className="desc_subtxt">{trackId}</span>
          </Link>
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          {linkedServiceNamesTitle ? (
            <TrackerServiceTooltip data={trackLinkedServices}>
              {linkedServiceNamesTitle}
            </TrackerServiceTooltip>
          ) : (
            '-'
          )}
        </div>
      </td>
      <td className={classNames({ align_r: showPopulation })}>
        <div className="inner_tbl">
          {lastEventTs
            ? showPopulation
              ? population.toLocaleString()
              : '미제공(권한 없음)'
            : '-'}
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          <p className="ad_state ico_state">
            {isNullOrUndefined(lastEventTs) ? (
              <>
                <span className="ico_off">off</span>수집전
              </>
            ) : (
              <>
                <span className="ico_on">on</span>수집중
              </>
            )}
          </p>
        </div>
      </td>
      <td>
        <div className="inner_tbl">
          {role === 'REQUEST' ? (
            <>
              <span className="f_right">
                <Button
                  size="small"
                  onClick={handleCancel}
                  disabled={isSubmitting}>
                  취소
                </Button>
              </span>
              멤버 권한 요청중
            </>
          ) : role === 'MASTER' ? (
            '마스터'
          ) : (
            '멤버'
          )}
        </div>
      </td>
      <td className="align_c">
        <div className="inner_tbl">
          {role === 'REQUEST' ? (
            <p className="txt_info">
              권한 요청 수락 후<br />
              연동 필요
            </p>
          ) : (
            <Button size="small" onClick={showLinkConfirm}>
              연동하기
            </Button>
          )}
        </div>
      </td>
      <LinkConfirm title="픽셀 & SDK 연동" onClose={handleDelete}>
        광고계정에 해당 픽셀 & SDK를 연동하시겠습니까?
      </LinkConfirm>
    </>
  )
}

export default UnLinkedTrackItem

UnLinkedTrackItem.propTypes = {
  data: PropTypes.shape({
    trackId: PropTypes.string.isRequired,
    trackName: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    trackLinkedServices: PropTypes.object,
    linkedServiceNamesTitle: PropTypes.string,
    population: PropTypes.number,
    lastEventTs: PropTypes.number,
    adAccountLinkStatus: PropTypes.string,
    requestId: PropTypes.number,
  }),
}
